module.exports = __webpack_public_path__ + "static/media/logo-mercantilAndina.992a5236.svg";